import { gql } from "@apollo/client";
import { logicaErrorBody } from "./helper";
import { createIdcToken } from "./helper";
import { v4 as uuidv4 } from "uuid";
import { UserInputError } from "apollo-server-errors";
import { AUTH_ERROR_MESSAGES } from "@/lib/errors";
import calcAge from "@/lib/calcAge";
import { SIGNUP_RESTRICTION_AGE, SIGNUP_RESTRICTION_AGE_MESSAGE } from "@/lib/constants";
export const typeDef = gql`
  type IdcAccessTokenResponse @cacheControl(scope: PRIVATE, maxAge: 0) {
    access_token: String
    expires_in: String
    refresh_token: String
    scope: String
    error: String
    error_description: String
    interval: String
  }
  type IdcUserInfo @cacheControl(scope: PRIVATE, maxAge: 0) {
    sub: String
    iss: String
    aud: String
    email: String
    name: String
    namekana: String
    gender: String
    birthdate: String
  }
  type IdcTokenVerifyInfo @cacheControl(scope: PRIVATE, maxAge: 0) {
    access_token: String
    token_type: String
    expires_in: String
    user_id: String
    elipsis_flg: String
    client_id: String
  }

  type Query {
    idcUserInfoEndPoint: IdcUserInfo
  }
  type Query {
    idcUserInfoEndPointAgeValidate: IdcUserInfo
  }
  type Query {
    idcTokenVerifyEndPoint: IdcTokenVerifyInfo
  }
  type Mutation {
    idcTokenEndPoint(code: String, redirectUri: String): IdcAccessTokenResponse
  }
`;
export const resolvers = {
  Query: {
    idcUserInfoEndPoint: async (_parent, args, _ref) => {
      let {
        req,
        res,
        dataSources
      } = _ref;
      try {
        return await dataSources.idc.userInfoEndPoint();
      } catch (e) {
        console.log("error", e);
        return e;
      }
    },
    idcUserInfoEndPointAgeValidate: async (_parent, args, _ref2) => {
      let {
        req,
        res,
        dataSources
      } = _ref2;
      try {
        var _idcUserInfo$birthdat;
        const idcUserInfo = await dataSources.idc.userInfoEndPoint();
        const birthday = (_idcUserInfo$birthdat = idcUserInfo.birthdate) === null || _idcUserInfo$birthdat === void 0 ? void 0 : _idcUserInfo$birthdat.replace(new RegExp("/", "g"), "-");
        const age = calcAge(birthday);
        console.log("age:" + age);
        if (age < SIGNUP_RESTRICTION_AGE) {
          throw new UserInputError(SIGNUP_RESTRICTION_AGE_MESSAGE);
        }
        return idcUserInfo;
      } catch (e) {
        console.log("error", e);
        return e;
      }
    },
    idcTokenVerifyEndPoint: async (_parent, args, _ref3) => {
      let {
        req,
        res,
        dataSources
      } = _ref3;
      try {
        return await dataSources.idc.tokenVerifyEndPoint();
      } catch (e) {
        var _e$extensions;
        console.log("verify token error", e);
        console.log("verify token error code", e === null || e === void 0 || (_e$extensions = e.extensions) === null || _e$extensions === void 0 ? void 0 : _e$extensions.code);
        throw new UserInputError(AUTH_ERROR_MESSAGES["unauthorized"]);
      }
    }
  },
  Mutation: {
    idcTokenEndPoint: async (_parent, _ref4, _ref5) => {
      let {
        code,
        redirectUri
      } = _ref4;
      let {
        req,
        res,
        dataSources
      } = _ref5;
      try {
        const result = await dataSources.idc.tokenEndPoint(code, redirectUri);
        const token = await createIdcToken(req, res, result.access_token, result.refresh_token, result.id_token, uuidv4());
        return result;
      } catch (e) {
        console.log("error", e);
        return e;
      }
    }
  }
};